import { useGetMilestoneSuggestedStepsQuery } from '@/store/api/milestoneApi';

export const useGrowthPlanSuggestedSteps = (growthPlanId: string) => {
  const {
    data: suggestions = [],
    isLoading,
    refetch,
  } = useGetMilestoneSuggestedStepsQuery(growthPlanId, {
    skip: !growthPlanId,
  });

  return {
    isSuggestedStepsLoading: isLoading,
    refetchAllSuggestions: refetch,
    suggestions,
  };
};
